const CHECKBOX_RANGES = new Map();

function handleClick(e) {
  if (e.target.matches(`input[type="checkbox"]`)) {
    let checkbox = e.target;
    let name = checkbox.getAttribute("name");
    let range = CHECKBOX_RANGES.get(name);
    let selector = `input[type="checkbox"][name="${name}"]`;
    if (!range) {
      range = CHECKBOX_RANGES.set(name, {
        last: null, elements: Array.from(document.querySelectorAll(selector))
      }).get(name);
    }
    if (e.shiftKey && range.last) {
      let from = range.elements.indexOf(range.last);
      let to = range.elements.indexOf(checkbox);
      let start = Math.min(from, to);
      let end = Math.max(from, to) + 1;
      for (let cb of range.elements.slice(start, end).filter(item => !item.hasAttribute("disabled"))) {
        cb.checked = checkbox.checked;
      }
    }
    document.dispatchEvent(new CustomEvent("checkboxRangeChange", {
      "detail": {
        name, range, selector,
        selectedCount: range.elements.filter(item => item.checked).length,
      }
    }));
    range.last = checkbox;
  }
}

function setUp() {
  document.body.addEventListener("click", handleClick);
}

function clear() {
  CHECKBOX_RANGES.clear();
}

export {
  handleClick, setUp, clear
}